<template>
  <div v-if="answerSheet" class="re-report text-center">
    <h1 class="dastnevis py-5">تقدیرنامه مطالعه کتاب را بگیرم</h1>
    <v-btn
      :loading="loading"
      color="success"
      depressed
      @click="
        print(
          answerSheet._id,
          answerSheetFaDate,
          answerSheet.user.firstname,
          answerSheet.user.lastname,
          answerSheet.book.title,
          answerSheetBgPrint,
          badge,
          schoolImg,
          schoolId
        )
      "
    >
      چاپ گواهینامه
    </v-btn>
    <div id="printd">
      <v-img class="rounded elevation-5 mt-5 mb-16" :src="answerSheetBg">
        <img width="16.5%" class="re-img" src="~@/assets/images/mainpage.gif" />
        <img
          v-if="schoolImg"
          class="re-schoolImg"
          width="6%"
          :src="'https://api.pirls.ir/school/image/' + schoolId"
        />
        <div class="position-absolute dastnevis re-name">
          {{ answerSheet.user.firstname + " " + answerSheet.user.lastname }}
        </div>
        <div class="position-absolute dastnevis re-book">
          {{ answerSheet.book.title }}
        </div>
        <div class="position-absolute dastnevis re-number">
          شماره: {{ answerSheet._id }}
        </div>
        <div class="position-absolute dastnevis re-date">
          تاریخ: {{ answerSheetFaDate }}
        </div>
        <img class="re-badge" width="9%" :src="badge" />
      </v-img>
    </div>

    <MenuComponent :book-id="this.$route.params.id" state="certificate" />
  </div>
</template>
<script>
import MenuComponent from "./Menu.vue";

export default {
  name: "certificate-component",
  components: { MenuComponent },
  data() {
    return {
      loading: false,
      answerSheet: null,
      badge: "",
      answerSheetBg: "",
      answerSheetBgPrint: "",
      answerSheetFaDate: "",
      schoolImg: false,
      schoolId: "none"
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/certificate/" + this.$route.params.id).then((res) => {
        this.answerSheet = res.data.answerSheet;
        this.certificateType();
        if (res.data.answerSheet.totalScore <= 3) {
          this.$router.push({
            name: "Exam",
            params: { Id: this.$route.params.id }
          });
          this.$store.commit("clearMessageState");
          this.$store.commit("setMessageState");
          this.$store.commit("setMessageType", "warning");
          this.$store.commit(
            "setMessage",
            "شما در آخرین آزمون خود نمره مناسب دریافت نکرده اید؛ لطفا دوباره تلاش نمایید"
          );
        }
        const date = res.data.answerSheet.createDate;
        this.answerSheetFaDate = this.$moment(date, "YYYY/MM/DD")
          .locale("fa")
          .format("YYYY/MM/DD");

        this.$api
          .get("certificate/hasSchool/" + this.$route.params.id)
          .then((res) => {
            this.schoolImg = true;
            this.schoolId = res.data.school._id;
          });
      });
    },

    certificateType() {
      const grade = this.answerSheet.book.grade;
      var type = false;
      if (
        grade === "اول دبستان" ||
        grade === "دوم دبستان" ||
        grade === "سوم دبستان"
      ) {
        type = true;
      }

      if (type) {
        this.answerSheetBg = require("@/assets/images/certificate/level-1.png");
        this.answerSheetBgPrint = require("@/assets/images/certificate/level-1-print.png");
      } else {
        this.answerSheetBg = require("@/assets/images/certificate/level-2.png");
        this.answerSheetBgPrint = require("@/assets/images/certificate/level-2-print.png");
      }

      if (this.answerSheet.totalScore >= 10) {
        this.badge = require("@/assets/images/certificate/Gold.png");
      } else if (this.answerSheet.totalScore >= 7) {
        this.badge = require("@/assets/images/certificate/Silver.png");
      } else {
        this.badge = require("@/assets/images/certificate/Bronze.png");
      }
    },

    print(
      id,
      date,
      firstname,
      lastname,
      bookTitle,
      image,
      badge,
      schoolImg,
      schoolId
    ) {
      this.loading = true;

      const doc = this.$jspdf({
        orientation: "landscape",
        format: "a4"
      });

      var bg = "https://pirls.ir/" + image,
        badgeImg = "https://pirls.ir/" + badge,
        fullname = firstname + " " + lastname;

      if (schoolImg) {
        var schImage =
          "https://api.pirls.ir/" + "school/image/" + schoolId;

        doc.addImage(schImage, "PNG", 200, 40);
      }

      doc.setFont("iransansdn");

      doc.addImage(bg, "JPEG", 0, 0, 297, 210);

      doc.addImage(badgeImg, "JPEG", 135, 156, 30, 22);

      doc.setTextColor("#b4b4b4");
      doc.setFontSize("8");
      doc.text(id, 150, 183, {
        align: "center"
      });

      doc.setTextColor("#808080");
      doc.setFontSize("10");
      doc.text("تاریخ: " + date, 68, 50);

      doc.setTextColor("#645ea0");
      doc.setFontSize("35");
      doc.text(fullname, 150, 110, {
        align: "center"
      });

      doc.setTextColor("#f39e24");
      doc.setFontSize("20");
      doc.text(bookTitle, 150, 133, {
        align: "center"
      });

      doc.save("Certificate.pdf");

      this.loading = false;
    }
  }
};
</script>
<style scoped>
.re-img {
  position: absolute;
  top: 16.5%;
  left: 50%;
  transform: translate(-50%, -16.5%);
}
.re-name {
  font-size: 2.8rem;
  font-weight: bold;
  color: #645ea0;
  position: absolute;
  top: 51%;
  left: 50%;
  transform: translate(-50%, -51%);
}
.re-schoolImg {
  position: absolute;
  top: 24%;
  right: 20%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
}
.re-book {
  font-size: 1.6rem;
  font-weight: bold;
  color: #f39e24;
  position: absolute;
  top: 62.8%;
  left: 50%;
  transform: translate(-50%, -62.8%);
}
.re-date {
  font-size: 0.7rem;
  font-weight: bold;
  color: #808080;
  position: absolute;
  text-align: left;
  top: 24%;
  left: 24%;
  transform: translate(-25%, -25%);
}
.re-number {
  font-size: 0.6rem;
  font-weight: bold;
  color: #b4b4b4;
  position: absolute;
  bottom: 12.5%;
  left: 50%;
  transform: translate(-50%, -12.5%);
}
.re-badge {
  position: absolute;
  bottom: 14%;
  left: 50%;
  transform: translate(-50%, -14%);
}

@media only screen and (max-width: 900px) {
  .re-name {
    font-size: 1.5rem;
  }
  .re-book {
    font-size: 1rem;
  }
  .re-date {
    font-size: 0.5rem;
  }
  .re-number {
    font-size: 0.4rem;
  }
}
@media only screen and (max-width: 500px) {
  .re-name {
    font-size: 1rem;
  }
  .re-book {
    font-size: 0.5rem;
  }
  .re-date {
    font-size: 0.3rem;
  }
  .re-number {
    font-size: 0.2rem;
  }
}
</style>
